import React, { useState, useEffect } from 'react';
import './document.css';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import { isMobile } from 'react-device-detect';
import Avatar from 'antd/lib/avatar/avatar';
import { MailOutlined, PhoneOutlined, UserOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import tlf from '../../../assets/icons/tlf.png';
import whatsapp from '../../../assets/icons/whatsapp.png';
import linkdn from '../../../assets/icons/linkdn.png';
import x from '../../../assets/icons/x.png';
import mail from '../../../assets/icons/mail.png';

const { Text } = Typography;

const PersonalAnalyst = (analyst) => {
	const { t } = useTranslation();
	const userToken = useSelector((state) => state.auth.token);

	const rol = useSelector((state) => state.auth.roles);
	const [dataValues, setDataValues] = useState();

	let mortgageId = analyst.userMortgageId;

	if (mortgageId === undefined) {
		mortgageId =
			analyst.analyst.operationId !== undefined ? analyst.analyst.operationId : analyst.analyst.id;
	}

	useEffect(() => {
		getPhoto();
	}, []);

	const getPhoto = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/agents/${mortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setDataValues(response.data.data);
			});
	};

	return (
		<>
			{dataValues !== undefined && !isMobile ? (
				<div style={{ color: '#988d8d', textAlign: 'center' }}>
					{/* START B2C */}

					{rol !== 'realestate' && (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								marginBottom: 24
							}}>
							<Avatar
								size={130}
								style={{
									fontSize: 40,
									background: dataValues?.analyst?.avatar !== null ? '#FCFAF5' : undefined
								}}
								src={
									dataValues &&
									dataValues.analyst &&
									dataValues?.analyst?.avatar !== null &&
									dataValues?.analyst?.avatar?.link
								}>
								{dataValues?.analyst?.name ? dataValues?.analyst?.name[0].toUpperCase() : 'U'}
							</Avatar>
						</div>
					)}
					<Text style={{ color: '#666', fontSize: 12, fontWeight: 400 }}>
						{t('document.personalAnalyst').toUpperCase()}
					</Text>
					{rol !== 'realestate' && (
						<span
							className="analyst-name-style title-head"
							style={{ marginTop: 8, marginBottom: 12 }}>
							{dataValues && dataValues.analyst && dataValues.analyst.name !== null
								? dataValues.analyst.name
								: 'No Name'}
						</span>
					)}
					<div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
						<a
							href={`https://api.whatsapp.com/send?phone=%2B34${dataValues?.analyst?.phone
								.split(' ')
								.join('')}`}
							target="_blank">
							<img src={whatsapp} alt="tlf" style={{ width: 28, height: 28 }}></img>
						</a>
						<a href="https://www.linkedin.com/company/engel-v%C3%B6lkers-finance/" target="_blank">
							<img src={linkdn} alt="tlf" style={{ width: 28, height: 28 }}></img>
						</a>
					</div>
					<div
						style={{
							border: '1px solid var(--Secondary-Idle, #0D0D0D)',
							borderRadius: 2,
							padding: '8px 24px 8px 16px',
							marginBottom: 16,
							marginTop: 24,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 8,
							cursor: 'pointer'
						}}>
						<PhoneOutlined style={{ transform: 'rotate(90deg)', fontSize: 20, color: '#0D0D0D' }} />
						<Text style={{ color: '#0D0D0D', fontSize: 16, fontWeight: 400 }}>
							{dataValues && dataValues.analyst && dataValues.analyst.phone !== null
								? dataValues.analyst.phone
								: 'No Number'}
						</Text>
					</div>

					<a href={`mailto:${dataValues?.analyst?.email}`} target="_blank">
						<Button
							style={{
								height: 40,
								width: '100%',
								borderRadius: 2,
								padding: '8px 24px 8px 16px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								gap: 8,
								boxShadow: 'none',
								backgroundColor: '#C80000',
								borderColor: '#C80000'
							}}>
							<MailOutlined style={{ fontSize: 20, color: 'white' }} />
							<Text style={{ fontSize: 16, fontWeight: 400, color: 'white' }}>
								{t('doc.contact')}
							</Text>
						</Button>
					</a>
				</div>
			) : null}

			{dataValues !== undefined && isMobile ? (
				<div className="personalInfo" style={{ color: '#988d8d', marginTop: -60 }}>
					{rol != 'realestate' && (
						<div
							style={{
								marginLeft: '60px',
								marginBottom: '10px',
								marginTop: 70
							}}>
							<Avatar
								size={60}
								icon={<UserOutlined />}
								src={
									dataValues && dataValues.analyst && dataValues.analyst.avatar !== null
										? dataValues.analyst.avatar.link
										: 'https://gibobs-assets.s3.eu-central-1.amazonaws.com/assets-dev/6008ddb40164df16002f94c6b1_608a71a603b0c458502cd74a93?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIS4QMZRS5JUUI7VA%2F20210719%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20210719T064357Z&X-Amz-Expires=300&X-Amz-Signature=7cca0a6445382b1fb12bf1176fb7a3b3e205a9b852e61288ec043e42e51f25ef&X-Amz-SignedHeaders=host' //""
								}
							/>
						</div>
					)}

					{rol !== 'realestate' && (
						<span
							style={{
								marginTop: '20px',
								fontSize: '12px',
								color: '#262626',
								lineHeight: '100%',
								textAlign: 'center',
								display: 'flex',
								justifyContent: 'center'
							}}>
							{dataValues && dataValues.analyst && dataValues.analyst.name !== null
								? dataValues.analyst.name
								: 'No Name'}
						</span>
					)}

					{rol !== 'realestate' && (
						<div
							style={{
								color: '#C80000',
								marginTop: '2px',
								marginLeft: '-20px',
								textAlign: 'center'
							}}>
							<span
								style={{
									marginLeft: '25px',
									fontSize: '16px',
									color: '#C80000',
									fontWeight: 'bold',
									lineHeight: '100%',
									border: 'none'
								}}>
								{dataValues && dataValues.analyst && dataValues.analyst.phone !== null
									? dataValues.analyst.phone
									: 'No Number'}
							</span>
						</div>
					)}

					{rol !== 'realestate' && (
						<div
							style={{
								color: '#666666',
								marginTop: '0px',
								marginLeft: '-20px',
								textAlign: 'center'
							}}>
							<span
								style={{
									marginLeft: '15px',
									fontSize: '10px',
									color: '#666666',
									fontWeight: 400,
									lineHeight: '100%',
									border: 'none'
								}}>
								{dataValues && dataValues.analyst && dataValues.analyst.email !== null
									? dataValues.analyst.email.replace('hipotecaprimero', 'gibobs')
									: 'No email'}
							</span>
						</div>
					)}
				</div>
			) : null}
		</>
	);
};

export default PersonalAnalyst;
